<template>
    <div v-parallax-fit="parallax" class="sleepingarea">
        <img src="/themes/rise-theme/dist/images/estate/character-view/holly/19_Neighbordhoo.png" alt="">

        <div v-parallax-fit="rentincrease" class="rent-increase">
            <img src="/themes/rise-theme/dist/images/estate/character-view/holly/18_RentIncrease.png" alt="">
        </div>

        <div class="icons-wifi">
            <div class="wifi" ref="wifi_1" v-parallax-fit="wifi_1">
                <img src="/themes/rise-theme/dist/images/estate/character-view/holly/21_MobileUprising_1@2x.png" alt="">
            </div>

            <div class="wifi" v-parallax-fit="wifi_2">
                <img src="/themes/rise-theme/dist/images/estate/character-view/holly/21_MobileUprising_1@2x.png" alt="">
            </div>

            <div class="wifi" v-parallax-fit="wifi_2">
                <img src="/themes/rise-theme/dist/images/estate/character-view/holly/21_MobileUprising_1@2x.png" alt="">
            </div>

            <div class="wifi" v-parallax-fit="wifi_2">
                <img src="/themes/rise-theme/dist/images/estate/character-view/holly/21_MobileUprising_1@2x.png" alt="">
            </div>

            <div class="wifi" v-parallax-fit="wifi_2">
                <img src="/themes/rise-theme/dist/images/estate/character-view/holly/21_MobileUprising_1@2x.png" alt="">
            </div>

            <div class="wifi" v-parallax-fit="wifi_2">
                <img src="/themes/rise-theme/dist/images/estate/character-view/holly/21_MobileUprising_1@2x.png" alt="">
            </div>

            <div class="wifi" v-parallax-fit="wifi_3">
                <img src="/themes/rise-theme/dist/images/estate/character-view/holly/21_MobileUprising_1@2x.png" alt="">
            </div>

            <div class="wifi" v-parallax-fit="wifi_3">
                <img src="/themes/rise-theme/dist/images/estate/character-view/holly/21_MobileUprising_1@2x.png" alt="">
            </div>

            <div class="wifi" v-parallax-fit="wifi_3">
                <img src="/themes/rise-theme/dist/images/estate/character-view/holly/21_MobileUprising_1@2x.png" alt="">
            </div>

            <div class="wifi" v-parallax-fit="wifi_3">
                <img src="/themes/rise-theme/dist/images/estate/character-view/holly/21_MobileUprising_1@2x.png" alt="">
            </div>

            <div class="wifi" v-parallax-fit="wifi_4">
                <img src="/themes/rise-theme/dist/images/estate/character-view/holly/21_MobileUprising_1@2x.png" alt="">
            </div>

            <div class="wifi" v-parallax-fit="wifi_4">
                <img src="/themes/rise-theme/dist/images/estate/character-view/holly/21_MobileUprising_1@2x.png" alt="">
            </div>

            <div class="wifi" v-parallax-fit="wifi_2">
                <img src="/themes/rise-theme/dist/images/estate/character-view/holly/21_MobileUprising_1@2x.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      mutationObserver: null,
      mutationObserver2: null,
      parallax: [
        {
          start: 9000,
          end: 12000,
          fromStyle: { transform: 'translateX(-50%) translateY(-250%) rotateZ(0deg)' },
          toStyle: { transform: 'translateX(-50%) translateY(50%) rotateZ(0deg)' },
          easing: 'linear'
        },
        {
          start: 17600,
          end: 18400,
          fromStyle: { transform: 'translateX(-50%) translateY(50%) rotateZ(0deg)' },
          toStyle: { transform: 'translateX(-50%) translateY(350%) rotateZ(20deg)' },
          easing: 'linear'
        }
      ],
      rentincrease: [
        {
          start: 12500,
          end: 13000,
          fromStyle: { width: '0%' },
          toStyle: { width: '100%' },
          easing: 'linear'
        },
        {
          start: 13800,
          end: 14800,
          fromStyle: { transform: 'translateY(0%)' },
          toStyle: { transform: 'translateY(350%)' },
          easing: 'linear'
        }
      ],
      wifi_1: [
        {
          start: 15700,
          end: 16200,
          fromStyle: { transform: 'scale(0)' },
          toStyle: { transform: 'scale(4)' },
          easing: 'linear'
        },
        {
          start: 16400,
          end: 16800,
          fromStyle: { transform: 'scale(4)' },
          toStyle: { transform: 'scale(5)' },
          easing: 'linear'
        },
        {
          start: 16800,
          end: 17200,
          fromStyle: { transform: 'scale(5)' },
          toStyle: { transform: 'scale(7)' },
          easing: 'linear'
        }
      ],
      wifi_2: [
        {
          start: 15700,
          end: 16200,
          fromStyle: { transform: 'scale(0)' },
          toStyle: { transform: 'scale(1)' },
          easing: 'linear'
        },
        {
          start: 16400,
          end: 16800,
          fromStyle: { transform: 'scale(1)' },
          toStyle: { transform: 'scale(2)' },
          easing: 'linear'
        },
        {
          start: 16800,
          end: 17200,
          fromStyle: { transform: 'scale(2)' },
          toStyle: { transform: 'scale(4)' },
          easing: 'linear'
        }
      ],
      wifi_3: [
        {
          start: 16200,
          end: 16600,
          fromStyle: { transform: 'scale(0)' },
          toStyle: { transform: 'scale(1)' },
          easing: 'linear'
        }
      ],
      wifi_4: [
        {
          start: 16600,
          end: 17000,
          fromStyle: { transform: 'scale(0)' },
          toStyle: { transform: 'scale(1)' },
          easing: 'linear'
        }
      ]
    }
  },
  mounted() {
    const self = this;
    const evidence = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/holly/evidence/9.png',
          url: 'https://pestakeholder.org/media_coverage/npr-how-the-government-helps-investors-buy-mobile-home-parks-raise-rent-and-evict-people/',
          link_title: {
			'en': "NPR: How the government helps investors buy mobile home parks, raise rent and evict people",
			'es': 'NPR: Cómo el gobierno ayuda a los inversionistas a comprar parques de casas móviles, aumentar el alquiler y desalojar a las personas'
		  },
        }
      ],
      text: {
		'en': `“When private investors come to buy parks, [they] raise the rent, sometimes 20, sometimes 50, sometimes 70 percent” and what’s really troubling “is that the government is basically turbo-charging this trend.”`,
		'es': '“Cuando los inversionistas privados vienen a comprar parques, [ellos] aumentan la renta, a veces un 20, a veces un 50, a veces un 70 por ciento” y lo que es realmente preocupante “es que el gobierno básicamente está acelerando esta tendencia”.'
	  }
    };
    const text = {
		'en': "When private companies like Havenpark buys new manufactured home communities, they almost invariably raise the rent, in some cases by as much as 70%.",
		'es': 'Cuando empresas privadas como Havenpark compran nuevas comunidades de casas prefabricadas, casi invariablemente aumentan el alquiler, en algunos casos hasta en un 70%.'
	};

    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.target.style.transform == 'translateX(-50%) translateY(50%) rotateZ(0deg)') {
          self.$evidence.value = JSON.stringify(evidence);
          self.$readMore.value = text;
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('.sleepingarea'), {
      attributes: true,
      attributeFilter: ['style']
    });

    const evidence2 = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/holly/evidence/11.png',
          url: 'https://homeless.cnsmaryland.org/2021/01/17/wall-street-investors-pricing-americans-out-of-last-bastion-of-affordable-housing/',
          link_title: {
			'en': "Wall Street investors pricing Americans out of last bastion of affordable housing.",
			'es': 'Los inversionistas de Wall Street están sacando a los estadounidenses del último bastión de viviendas asequibles.'
		  },
        }
      ],
      text: {
		'en': `“We create value through aggressive optimization programs and lean property management systems,“ Havenpark's investor site said formerly claimed. “Tenant turnover is also minimal since it is difficult and very expensive ($6,000-8,000+) for tenants to move their homes. As a result, operating cash flow is among the highest of any real estate class.” Havenpark’s current website no longer includes this language, but the Howard Center for Investigative Journalism viewed archived versions of the website.`,
		'es': '“Creamos valor a través de programas de optimización agresivos y sistemas de administración de propiedades eficientes”, dijo anteriormente el sitio para inversionistas de Havenpark. “La rotación de inquilinos también es mínima ya que es difícil y muy costoso ($6,000-8,000+) para los inquilinos mudar sus casas. Como resultado, el flujo de efectivo operativo se encuentra entre los más altos de cualquier clase de bienes raíces”. El sitio web actual de Havenpark ya no incluye este idioma, pero el Centro Howard para el Periodismo de Investigación vio versiones archivadas del sitio web.'
	  }
    };
    const text2 = {
		'en': `Raising rent is central to Havenpark’s business model, which they describe as finding "undervalued assets" and increasing the rent prices as high as demand will allow. Havenpark is able to dramatically raise rents because manufactured home residents have few other options and are rarely able to move their manufactured homes, essentially locking them in place.`,
		'es': 'El aumento de la renta es fundamental para el modelo comercial de Havenpark, que describen como encontrar "activos infravalorados" y aumentar los precios de la renta tanto como lo permita la demanda. Havenpark puede aumentar dramáticamente los alquileres porque los residentes de casas prefabricadas tienen pocas opciones y rara vez pueden mudar sus casas prefabricadas, esencialmente bloqueándolas en su lugar.'
	};
    this.mutationObserver2 = new window.MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.target.style.transform == 'scale(4)') {
          self.$evidence.value = JSON.stringify(evidence2);
          self.$readMore.value = text2;
        }
      });
    });

    this.mutationObserver2.observe(this.$refs.wifi_1, {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
    this.mutationObserver2.disconnect();
  }
}
</script>

<style lang="scss" scoped>
    .sleepingarea {
        position: absolute;
        bottom: 50%;
        left: 50%;
        z-index: -3;
        max-width: 1000px;
        width: 100%;
        transition: all 0.1s linear;

        .rent-increase {
            position: absolute;
            top: 11%;
            left: 0;
            width: 0;
            overflow: hidden;

            img {
                display: block;
                min-width: 950px;
            }
        }
    }

    .icons-wifi {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;

        .wifi {
            width: 40px;
            position: absolute;
            transition: all 0.1s linear;
            transform: scale(0);

            &:nth-child(1) {
                left: 57%;
                bottom: 29%;
            }

            &:nth-child(2) {
                left: 29%;
                bottom: 29%;
            }

            &:nth-child(3) {
                left: 18%;
                bottom: 40%;
            }

            &:nth-child(4) {
                left: 39%;
                bottom: 42%;
            }

            &:nth-child(5) {
                left: 57%;
                bottom: 46%;
            }

            &:nth-child(6) {
                right: 22%;
                bottom: 54%;
            }

            &:nth-child(7) {
                right: 26%;
                bottom: 61%;
            }

            &:nth-child(8) {
                right: 36%;
                bottom: 58%;
            }

            &:nth-child(9) {
                right: 48%;
                bottom: 53%;
            }

            &:nth-child(10) {
                left: 12%;
                bottom: 55%;
            }

            &:nth-child(11) {
                left: 27%;
                bottom: 54%;
            }

            &:nth-child(12) {
                left: 38%;
                bottom: 62%;
            }

            &:nth-child(13) {
                left: 74%;
                bottom: 39%;
            }
        }
    }

    @media screen and (max-width: 1600px) {
        .sleepingarea .rent-increase img {
            min-width: 750px;
        }
    }

    @media screen and (max-width: 1024px) {
        .sleepingarea .rent-increase img {
            min-width: 700px;
        }


        .icons-wifi {
            .wifi {
                width: 20px;
            }
        }
    }

    @media screen and (max-width: 650px) {
        .sleepingarea .rent-increase img {
            min-width: 300px;
        }

        .icons-wifi {
            .wifi {
                width: 15px;
            }
        }
    }
</style>
